import { GenericResponse_$reflection, HideDocumentForm_$reflection, HideDocumentForm } from "../../Shared/ApiDataTypes.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { value as value_29, unwrap, map, defaultArg, some } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../../Promises.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { class_type, obj_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry2 } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { mapFetchError } from "../../Promises.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { DialogActions, DialogContentText, DialogContent, DialogTitle, Dialog, Button } from "@mui/material";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Components_TimedProgress_ZB2B7FD7 } from "../TimedProgress.js";
import Check from "@mui/icons-material/Check";
import { loadingIndicatorSmall } from "../../ViewHelpers.js";

export function DocumentsModule_resetDocVisibility(callback, doc) {
    let properties_2;
    let pr_2;
    let pr_1;
    const item_1 = new HideDocumentForm(doc.Guid, !doc.IsHidden);
    const data = some(Auto_generateBoxedEncoder_437914C6(HideDocumentForm_$reflection(), undefined, undefined, undefined)(item_1));
    const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
    const data_1 = data;
    const caseStrategy_3 = undefined;
    const extra_3 = undefined;
    try {
        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/document/hidden", properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then((res) => mapFetchError((_arg_2) => {
        if (_arg_2 === 500) {
            return "Noe gikk galt. Prøv igjen senere.";
        }
        else {
            return undefined;
        }
    }, res)));
    pr_2.then(callback);
}

export class Documents {
    constructor() {
    }
}

export function Documents_$reflection() {
    return class_type("Kundeweb.Components.Documents", undefined, Documents);
}

export function Documents_VisibilityPopup_Z6D335E41(documents_VisibilityPopup_Z6D335E41InputProps) {
    let elements_3, elements_1;
    const document$ = documents_VisibilityPopup_Z6D335E41InputProps.document;
    const onClose = documents_VisibilityPopup_Z6D335E41InputProps.onClose;
    const onUpdate = documents_VisibilityPopup_Z6D335E41InputProps.onUpdate;
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const updated = patternInput_1[0];
    const setUpdated = patternInput_1[1];
    const handleClose = () => {
        setLoading(false);
        setUpdated(false);
        onClose();
    };
    let action;
    const xs = [MuiHelpers_createElement(Button, toList(delay(() => append(singleton(["onClick", (_arg) => {
        handleClose();
    }]), delay(() => append(singleton(["color", "inherit"]), delay(() => append(singleton(["size", "small"]), delay(() => append(updated ? singleton(["startIcon", createElement(Components_TimedProgress_ZB2B7FD7, {
        onEnd: () => {
            handleClose();
        },
    })]) : empty_1(), delay(() => {
        let elements;
        return singleton((elements = toList(delay(() => (updated ? singleton("Lukk") : singleton("Nei")))), ["children", reactApi.Children.toArray(Array.from(elements))]));
    }))))))))))), MuiHelpers_createElement(Button, toList(delay(() => append(singleton(["onClick", (_arg_1) => {
        setLoading(true);
        DocumentsModule_resetDocVisibility((res) => {
            setLoading(false);
            console.debug("Got back document:", res, document$);
            if (res.tag === 0) {
                if (res.fields[0].Result === "success") {
                    setUpdated(true);
                    onUpdate(value_29(document$));
                }
            }
            else {
                console.error(some("Noe gikk galt. Vennligst prøv igjen senere:"), res.fields[0]);
            }
        }, value_29(document$));
    }]), delay(() => append(singleton(["size", "small"]), delay(() => (updated ? append(singleton(["color", "success"]), delay(() => append(singleton(["variant", "contained"]), delay(() => {
        let props_2;
        return singleton(["children", (props_2 = {}, react.createElement(Check, props_2))]);
    })))) : append(singleton(["color", "error"]), delay(() => singleton(["children", patternInput[0] ? loadingIndicatorSmall() : "Ja"])))))))))))];
    action = react.createElement(react.Fragment, {}, ...xs);
    return MuiHelpers_createElement(Dialog, [["open", document$ != null], ["onClose", (delegateArg, delegateArg_1) => {
        handleClose();
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", "Dokumentet er flyttet til en synlig mappe"]]), MuiHelpers_createElement(DialogContent, [(elements_1 = [MuiHelpers_createElement(DialogContentText, [["children", "Dokumentet er fortsatt ikke synlig for kunder. Vil du gjøre dette dokumentet tilgjengelig? "]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray([action])]])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

